import React from 'react';
import { Text } from '../Typography/Typography';
import { calculateWeightedScore } from '../../store/evaluation/scoreWeighting';

interface Props {
  scores: { name: string; score: number }[];
  className?: string;
}

const EvaluationScore: React.FC<Props> = ({ scores, className }) => {
  const weightedScore = calculateWeightedScore(scores);
  const displayScore = weightedScore.toFixed(2);

  return (
    <Text weight="medium" color="neutral-600" className={className}>
      {displayScore}
    </Text>
  );
};

export default EvaluationScore;
